<button
  class="border-0 rounded-full z-0"
  mat-stroked-button
  aria-label="language"
  [matMenuTriggerFor]="previousStatementMenu">
  <mat-icon
    *ngIf="!translate.currentLang"
    class="fa-regular fa-language"></mat-icon>

  <span class="flex items-center">
    <img
      class="w-6"
      src="assets/icons/globe-32.png"
      alt="globe"
      width="24"
      height="24"
      loading="lazy" />

    <!-- spanish -->
    <span class="ml-3" *ngIf="translate.currentLang === 'es'">
      <span *ngIf="navbar">{{ 'language.es' | translate }}</span>
      {{ 'language.es:acronym' | translate }}
    </span>

    <!-- english -->
    <span class="ml-3" *ngIf="translate.currentLang === 'en'">
      <span *ngIf="navbar">{{ 'language.en' | translate }}</span>
      {{ 'language.en:acronym' | translate }}
    </span>

    <!-- portugues -->
    <span class="ml-3" *ngIf="translate.currentLang === 'pt'">
      <span *ngIf="navbar">{{ 'language.pt' | translate }}</span>
      {{ 'language.pt:acronym' | translate }}
    </span>
  </span>
</button>
<mat-menu #previousStatementMenu="matMenu">
  <button aria-label="Español" mat-menu-item (click)="setLang('es')">
    <span class="flex items-center">
      <span>{{ 'language.es:acronym' | translate }} Español</span>
    </span>
  </button>
  <button aria-label="Ingles" mat-menu-item (click)="setLang('en')">
    <span class="flex items-center">
      <span>{{ 'language.en:acronym' | translate }} English</span>
    </span>
  </button>
  <button aria-label="Portugues" mat-menu-item (click)="setLang('pt')">
    <span class="flex items-center">
      <span>{{ 'language.pt:acronym' | translate }} Português</span>
    </span>
  </button>
</mat-menu>
